"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const validatorJS = require("validator");
class IsBooleanStringValidator {
    isValid(input) {
        if (input) {
            return validatorJS.isBoolean(input);
        }
        return false;
    }
}
exports.IsBooleanStringValidator = IsBooleanStringValidator;
//# sourceMappingURL=IsBooleanStringValidator.js.map